{
  "members": "{{count}} deltagare",
  "members_plural": "{{count}} deltagare",
  "members-title": "Deltagare",
  "Groups": "Grupper",
  "Other groups": "Andra grupper",
  "Add participants": "Lägg till deltagare",
  "Step 1: ": "Steg 1: ",
  "Add one email per line.": "Lägg till en e-post per rad.",
  "Step 2: Choose realm for all participants.": "Steg 2: Välj realm för alla deltagare.",
  "Select realm": "Välj realm",
  "Select realm for all participants": "Välj realm för alla deltagare",
  "Are you sure you want to remove ": "Är du säker på att du vill ta bort? ",
  "Building CSV": "Skapar CSV",
  "found-groupmembers": "Hittade {{count}} gruppmedlem",
  "found-groupmembers_plural": "Hittade {{count}} gruppmedlemmar",
  "Filtered CSV": "Filtrerad CSV",
  "Participant": "Deltagare",
  "Organization": "Organisation",
  "Select an organization": "Välj en organisation",
  "Added": "Tillagd",
  "Sort by": "Sortera",
  "add-user": "Lägg till {{count}} deltagare",
  "add-user_plural": "Lägg till {{count}} deltagare"
}
